import type { MatchListItem } from "fansunited-sports-ui";
import type { AdaptedTeamEvent } from "@/utilities/data/team/types";
import { formatDateDDMM, formatDateTime, formatTimeHHMM } from "@/utilities/formatting/date";
import { idToUrlSegment } from "@/utilities/mappers/idUrlFormat";
import type { LogoUrlResolver } from "@/utilities/mappers/match";

export function mapEventToMatchListItem(
    event: AdaptedTeamEvent,
    isFinished: boolean,
    includeYearInDate: boolean,
    matchUrlBuilder?: (matchId: string) => string,
    logoUrlResolver?: LogoUrlResolver,
): MatchListItem {
    const kickoffDate = new Date(event.date);
    const matchIdForUrl = event.fansUnitedMatchId || event.id;

    const c1 = event.competitorOne;
    const c2 = event.competitorTwo;

    const c1LogoUrl = logoUrlResolver
        ? logoUrlResolver({
              logo: c1.assets?.logo,
              countryFlag: c1.country?.flag,
              countryCode: c1.country?.code,
          })
        : c1.assets?.logo || "";
    const c2LogoUrl = logoUrlResolver
        ? logoUrlResolver({
              logo: c2.assets?.logo,
              countryFlag: c2.country?.flag,
              countryCode: c2.country?.code,
          })
        : c2.assets?.logo || "";

    return {
        match: {
            id: matchIdForUrl,
            link: matchUrlBuilder ? matchUrlBuilder(matchIdForUrl) : `/match/${idToUrlSegment(matchIdForUrl)}`,
            competitorOne: {
                id: c1.id,
                name: c1.name,
                shortName: c1.shortName,
                logo: { url: c1LogoUrl, alt: c1.name },
                ...(isFinished &&
                    event.score && {
                        score: { main: event.score.fullTime.competitorOne || "0" },
                    }),
            },
            competitorTwo: {
                id: c2.id,
                name: c2.name,
                shortName: c2.shortName,
                logo: { url: c2LogoUrl, alt: c2.name },
                ...(isFinished &&
                    event.score && {
                        score: { main: event.score.fullTime.competitorTwo || "0" },
                    }),
            },
            period: {
                label: includeYearInDate ? formatDateTime(kickoffDate) : formatDateDDMM(kickoffDate),
            },
            status: isFinished ? "final" : "scheduled",
            metadata: {
                competition: event.competition.name || "",
                date: formatDateDDMM(kickoffDate),
                time: isFinished ? formatDateDDMM(kickoffDate) : formatTimeHHMM(kickoffDate),
                kickoffTime: kickoffDate.toISOString(),
            },
        },
        ...(!isFinished && {
            bettingOdds: undefined,
        }),
    };
}
